import{ ScrollTrigger }from"gsap/ScrollTrigger";

export{ bp, isMobile, innerW, innerH, mouse, varSpacer };

const bp = {
    mbl: 416,
    mblLG: 640,
    tbl: 900,
    lpt: 1100,
    lptLg: 1312,
    dsk: 1696
};

const isMobile = ("ontouchstart" in document.documentElement);

let innerW, innerH, varSpacer;
calcResize();

function calcResize(){
    ScrollTrigger.refresh();

    innerW = window.innerWidth;
    innerH = window.innerHeight;

    varSpacer = innerW * ((innerW > bp.mblLG) ? .027 : .053);
}

let debounceTimer;
function resizerDebounce(){
    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(() => {
        if(window.innerHeight !== innerH && isMobile){
            if(window.innerHeight > (innerH + innerH * .3) ||
                window.innerHeight < (innerH - innerH * .3)){
                calcResize();
            }

        }else calcResize();

    }, 500);
}

const mouse = {
    x: innerH / 2,
    y: innerW / 2,

    xPerc: 50,
    yPerc: 50,

    xFromCen: innerW / 2,
    yFromCen: innerH / 2,

    movementX: 0,
    movementY: 0
};

function mouseMove(e){
    mouse.x = e.clientX;
    mouse.y = e.clientY;

    mouse.xPerc = (mouse.x / innerW) * 100;
    mouse.yPerc = (mouse.y / innerH) * 100;

    mouse.xFromCen = (mouse.x - (innerW / 2));
    mouse.yFromCen = (mouse.y - (innerH / 2));

    mouse.movementX = e.movementX;
    mouse.movementY = e.movementY;
}

export default function initUtils(){
    if(!isMobile) window.addEventListener("mousemove", mouseMove);
    window.addEventListener("resize", resizerDebounce);
}